export default {
  namespaced: true,
  state: {
    cacheArticle: {}
  },
  mutations: {
    SET_CACHE_ARTICLE(state, article) {
      state.cacheArticle = article
    }
  },
  actions: {
    set_cache_article({commit}, article) {
      let timer = setTimeout(() => {
        commit('SET_CACHE_ARTICLE', article)
        clearTimeout(timer)
      }, 0)
    }
  },
  getters: {
    cacheArticleHtml: state => state.cacheArticle.html
  }
}